export default __webpack_public_path__ + "static/media/icons_users.9acfef99.svg";